import { useMutation, useQueryClient } from "@tanstack/react-query";

import { addCropExplorationEntry, addCropExplorationTemplateEntry } from "services";

import { ADD_CROP_EXPLORATION_ENTRY, GET_CROP_EXPLORATIONS, GET_CROP_EXPLORATION_TEMPLATES } from "consts";

export const useAddCropExplorationEntry = (isAdmin: boolean = false, skipInvalidation: boolean = false) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [ADD_CROP_EXPLORATION_ENTRY],
    mutationFn: !isAdmin ? addCropExplorationEntry : addCropExplorationTemplateEntry,
    onSuccess: () =>
      skipInvalidation ? Promise.resolve() : queryClient.invalidateQueries({ queryKey: [GET_CROP_EXPLORATIONS, GET_CROP_EXPLORATION_TEMPLATES] }),
  });
};
